document.addEventListener('DOMContentLoaded', function() {
  if (window.location.hash === '#newsletter') {
    // Initially scroll towards the bottom to trigger footer loading
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });

    // After a delay, check and scroll again to ensure we are at the very bottom
    setTimeout(function() {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }, 500); // Adjust the delay as needed to allow footer to load
  }
});
